export var AdSignalingEventKey = /*#__PURE__*/ function(AdSignalingEventKey) {
    AdSignalingEventKey["EventStream"] = "urn:sva:advertising-wg:ad-id-signaling";
    AdSignalingEventKey["HlsDaterange"] = "urn:sva:advertising-wg:ad-id-signaling";
    return AdSignalingEventKey;
}({});

//# sourceMappingURL=manifest-metadata.enums.js.map